import React, { useEffect, useState } from "react";
import Content from "../../../components/Contents/Content";
import { useFormik } from "formik";
import { GetTicketForhelp, GetAllTicketData } from "../../../Services/UserService/User";
import Loader from "../../../../Utils/Loader";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";
import Table from "../../../Extracomponents/Table1";
import { Eye } from "lucide-react";
import { Link } from "react-router-dom";
import { fDate } from "../../../../Utils/Date_formate";
import ReusableModal from '../../../components/Models/ReusableModal';
import { basicsettinglist } from "../../../Services/Admin/Admin";


const HelpDesk = () => {

    const [viewmodel2, setViewModel2] = useState(false);
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("id");
    const [messagedata, setMessagedata] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [clients, setClients] = useState([]);




    useEffect(() => {
        FetchMessage();
        getsettingdetail()
    }, [currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };



    const getsettingdetail = async () => {
        try {
            const response = await basicsettinglist(token);
            if (response.status) {
                setClients(response?.data);
            }
        } catch (error) {
            console.log('Error fetching settings:', error);
        }
    };

    




    const FetchMessage = async () => {
        try {
            const data = { page: currentPage, clientId: userid };
            const response = await GetAllTicketData(data, token);
            if (response.status) {
                setMessagedata(response.data);
                setTotalRows(response.pagination.total);
            }
        } catch (error) {
            console.error("Error fetching trade data:", error);
        }
        setIsLoading(false);
    };



    const Sendmessagedata = async (data) => {
        try {
            const response = await GetTicketForhelp(data, token);
            if (response.status) {
                showCustomAlert("Success", response.message);
                FetchMessage()
                setViewModel2(false)
            } else {
                showCustomAlert("error", response.message);
            }
        } catch (error) {
            showCustomAlert(
                "error",
                "An error occurred while sending the message. Please check your network or try again later."
            );
        }
    };




    const formik = useFormik({
        initialValues: {
            subject: "",
            message: "",
            file: '',
        },
        validate: (values) => {
            const errors = {};
            if (!values.subject) {
                errors.subject = "Please Enter Subject";
            }
            if (!values.message) {
                errors.message = "Please Enter Message";
            }
            return errors;
        },
        onSubmit: async (values, { resetForm }) => {
            const data = {
                client_id: userid,
                subject: values.subject,
                message: values.message,
                attachment: values.file,
            };

            await Sendmessagedata(data);

            resetForm();
        },
    });

    return (
        <>
            <Content Page_title="Help Desk" button_status={false}>

                {/* {(messagedata.length === 0 || messagedata.some(item => item.status == 2)) && (
                    <button className="btn btn-primary float-end" onClick={() => setViewModel2(true)}>
                        New Request
                    </button>
                )} */}
                {(messagedata.length === 0 || messagedata?.some(item => item?.status == 2)) && (
                    <div className="dropdown float-end mb-3">
                        <button
                            className="btn btn-primary dropdown-toggle d-flex align-items-center gap-2"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"

                        >
                            <i className="bi bi-plus-circle"></i>
                            New Request
                        </button>
                        <ul className="dropdown-menu shadow" style={{background:'rgb(24, 34, 31)'}}>
                            <li>
                                <button
                                    className="dropdown-item d-flex align-items-center gap-2 text-light bg-transparent"
                                    onClick={() => setViewModel2(true)}
                                >
                                    <i className="bi bi-chat-dots text-primary fs-5"></i>
                                    Ticket Request
                                </button>
                            </li>
                            <li>
                                <a
                                    href={`https://wa.me/91${clients[0]?.wh_number}?text=Hello%2C%20I%20would%20like%20to%20chat%20with%20you`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="dropdown-item d-flex align-items-center gap-2 text-light  bg-transparent"
                                >
                                    <i className="bi bi-whatsapp text-success fs-5"></i>
                                    WhatsApp Chat
                                </a>
                            </li>

                        </ul>
                    </div>
                )}



                <div className="table-responsive mt-2">
                    {messagedata.length > 0 ? (
                        <Table
                            columns={[
                                {
                                    name: "Ticket No.",
                                    selector: (row) => `#${row?.ticketnumber}`,
                                    width: "20%"
                                },
                                {
                                    name: "Subject",
                                    selector: (row) => row?.subject,
                                    width: "20%"
                                },
                                {
                                    name: "Created At",
                                    selector: (row) => fDate(row?.created_at),
                                    width: "20%"
                                },
                                {
                                    name: "Status",
                                    cell: (row) => (
                                        <div>
                                            <span
                                                className={`badge ${row.status === 0
                                                    ? "bg-warning text-dark"
                                                    : row.status === 1
                                                        ? "bg-success"
                                                        : "bg-danger"
                                                    }`}
                                            >
                                                {row.status === 0 ? "Pending" : row.status === 1 ? "Open" : "Close"}
                                            </span>
                                        </div>
                                    ),
                                    width: "20%"
                                },
                                {
                                    name: "Action",
                                    cell: (row) => (
                                        <Link to={`/user/help-desk-view/${row._id}`} className="btn btn-light btn-sm p-0">
                                            <Eye width="15px" />
                                        </Link>
                                    ),
                                    width: "20%"
                                },
                            ]}
                            data={messagedata}
                            totalRows={totalRows}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                        />
                    ) : (
                        <div className="text-center mt-5">
                            <img
                                src="/assets/images/nodata.png"
                                alt="No Records Found"
                                className="w-25"
                            />
                        </div>
                    )}
                </div>
            </Content>

            <ReusableModal
                show={viewmodel2}
                onClose={() => setViewModel2(false)}
                size="lg"
                title={<span><b>Add Message</b></span>}
                body={
                    <form onSubmit={formik.handleSubmit}>
                        <div className="form-group ">
                            <label htmlFor="subject">Subject</label>
                            <input
                                type="text"
                                id="subject"
                                name="subject"
                                className="form-control"
                                value={formik.values.subject}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.subject && formik.errors.subject && (
                                <div className="text-danger">{formik.errors.subject}</div>
                            )}
                        </div>

                        <div className="form-group mt-2">
                            <label htmlFor="message">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                className="form-control"
                                rows="4"
                                value={formik.values.message}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.message && formik.errors.message && (
                                <div className="text-danger">{formik.errors.message}</div>
                            )}
                        </div>

                        <div className="form-group mt-2">
                            <label htmlFor="file">Upload File</label>
                            <input
                                type="file"
                                id="file"
                                name="file"
                                className="form-control"
                                onChange={(event) => formik.setFieldValue('file', event.currentTarget.files[0])}
                            />
                            {formik.touched.file && formik.errors.file && (
                                <div className="text-danger">{formik.errors.file}</div>
                            )}
                        </div>

                        <button type="submit" className="btn btn-primary mt-2">
                            Submit
                        </button>
                    </form>
                }

            />
        </>
    );
};

export default HelpDesk;
